/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MarkAsDoneAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import Tysiav2BoardsClipboardIcon from 'DesignSystem/Svgs/Tysiav2BoardsClipboardIcon/index'



/** @type {import('Simple/types.js').View} */
export default function MarkAsDoneAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/TaskOverlay/Content/Content/Footer/MarkAsDoneAction"
  
}) {
let taskStageDoneValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'stage.done',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="task.stage.done"
 disabled={taskStageDoneValueData}
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2BoardsClipboardIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2BoardsClipboardIcon`}
 width={dtSpaceLs}
 fill2={dtColorsWhite}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Mark as done"
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}